import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Button, Col, Modal } from 'react-bootstrap';
import { isEmpty } from 'lodash';

import { LAYER_SUBTYPES } from '../../../api/Layers/Layers';

import getImageGeoreferencing from '../../../modules/get-image-georeferencing';
import handleErrorInClient from '../../../modules/handle-error-in-client';

import Loading from '../../components/Loading';
import MapContainerGeoImage from '../../containers/MapContainerGeoImage';

const EMPTY_URL_ERROR = 'Empty URL';

class LayerGeoImageFields extends Component {
  state = {
    canAddPoint: false,
    geoImageOpacity: 70,
    geoImageURL: '',
    loading: false,
    showModal: false
  };

  activateAddingPoints = () => this.setState({ canAddPoint: true });

  changeOpacity = event => this.setState({ geoImageOpacity: Number(event.target.value) });

  closeModal = () => this.setState({ showModal: false });

  checkURL = async event => {
    const {
      topLeft: defaultTopLeft,
      topRight: defaultTopRight,
      bottomLeft: defaultBottomLeft,
      changeLayerEditorStateProperty
    } = this.props;

    const geoImageURL = event.target.form.url.value.trim();

    try {
      this.setState({ loading: true });

      if (isEmpty(geoImageURL)) throw new Error(EMPTY_URL_ERROR);

      if (isEmpty(defaultTopLeft) || isEmpty(defaultTopRight) || isEmpty(defaultBottomLeft)) {
        const { topLeft, topRight, bottomLeft } = await getImageGeoreferencing(geoImageURL);
        changeLayerEditorStateProperty('topLeft', topLeft);
        changeLayerEditorStateProperty('topRight', topRight);
        changeLayerEditorStateProperty('bottomLeft', bottomLeft);
      }

      this.setState({ geoImageURL, loading: false, showModal: true });
    } catch (error) {
      handleErrorInClient(error);
      this.setState({ loading: false });
    }
  };

  render() {
    const {
      bottomLeft,
      deployEnv,
      layer,
      layerSubType,
      topLeft,
      topRight,
      changeLayerEditorStateProperty,
      userControlSetting
    } = this.props;
    const { canAddPoint, geoImageOpacity, geoImageURL, loading, showModal } = this.state;

    if (layerSubType === LAYER_SUBTYPES.GEOIMAGE) {
      return (
        <>
          <Modal dialogClassName="mw-100 w-75" show={showModal} onHide={this.closeModal}>
            {loading && <Loading />}
            {!loading && (
              <>
                <Modal.Header closeButton>Select Points</Modal.Header>
                <Modal.Body>
                  <MapContainerGeoImage
                    bottomLeft={bottomLeft}
                    canAddPoint={canAddPoint}
                    deployEnv={deployEnv}
                    geoImageOpacity={geoImageOpacity}
                    geoImageURL={geoImageURL}
                    layer={layer}
                    layerSubType={layerSubType}
                    topLeft={topLeft}
                    topRight={topRight}
                    changeLayerEditorStateProperty={changeLayerEditorStateProperty}
                    userControlSetting={userControlSetting}
                  />
                </Modal.Body>
                <Modal.Footer>
                  <Form.Group as={Col} xs={12}>
                    <Form.Row>
                      <Form.Label column xs={3} sm={2} lg={1}>
                        Opacity
                      </Form.Label>
                      <Col xs={9} sm={10} md={7} lg={9}>
                        <Form.Control
                          type="range"
                          value={geoImageOpacity}
                          min="0"
                          max="100"
                          onChange={this.changeOpacity}
                        />
                      </Col>
                      <Col xs={12} md={3} lg={2}>
                        <Button
                          active={canAddPoint}
                          block
                          disabled={!isEmpty(bottomLeft) && !isEmpty(topLeft) && !isEmpty(topRight)}
                          onClick={this.activateAddingPoints}
                        >
                          Add Point
                        </Button>
                      </Col>
                    </Form.Row>
                  </Form.Group>
                </Modal.Footer>
              </>
            )}
          </Modal>
          <Form.Group as={Col} xs={12} className="px-0">
            <Button block variant="primary" onClick={this.checkURL}>
              Select Points for Georeferencing
            </Button>
          </Form.Group>
        </>
      );
    }
    return '';
  }
}

LayerGeoImageFields.propTypes = {
  bottomLeft: PropTypes.object.isRequired,
  deployEnv: PropTypes.string.isRequired,
  layer: PropTypes.object.isRequired,
  layerSubType: PropTypes.string.isRequired,
  topLeft: PropTypes.object.isRequired,
  topRight: PropTypes.object.isRequired,
  changeLayerEditorStateProperty: PropTypes.func.isRequired,
  userControlSetting: PropTypes.object.isRequired
};

export default LayerGeoImageFields;
